var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUserPrs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 2.33333C7.44325 2.33333 4.95825 4.81833 4.95825 7.875C4.95825 10.8733 7.30325 13.3 10.3599 13.405C10.4533 13.3933 10.5466 13.3933 10.6166 13.405C10.6399 13.405 10.6516 13.405 10.6749 13.405C10.6866 13.405 10.6866 13.405 10.6983 13.405C13.6849 13.3 16.0299 10.8733 16.0416 7.875C16.0416 4.81833 13.5566 2.33333 10.4999 2.33333Z",
    fill: "url(#paint0_linear_640_6059)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4266 16.5083C13.1716 14.3383 7.86329 14.3383 4.58495 16.5083C3.10329 17.5 2.28662 18.8417 2.28662 20.2767C2.28662 21.7117 3.10329 23.0417 4.57329 24.0217C6.20662 25.1183 8.35329 25.6667 10.5 25.6667C12.6466 25.6667 14.7933 25.1183 16.4266 24.0217C17.8966 23.03 18.7133 21.7 18.7133 20.2533C18.7016 18.8183 17.8966 17.4883 16.4266 16.5083Z",
    fill: "url(#paint1_linear_640_6059)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3219 8.56332C23.5086 10.8267 21.8986 12.81 19.6702 13.0783C19.6586 13.0783 19.6586 13.0783 19.6469 13.0783H19.6119C19.5419 13.0783 19.4719 13.0783 19.4136 13.1017C18.2819 13.16 17.2436 12.7983 16.4619 12.1333C17.6636 11.06 18.3519 9.44999 18.2119 7.69999C18.1302 6.75499 17.8036 5.89166 17.3136 5.15666C17.7569 4.93499 18.2702 4.79499 18.7952 4.74832C21.0819 4.54999 23.1236 6.25332 23.3219 8.56332Z",
    fill: "url(#paint2_linear_640_6059)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6551 19.355C25.5618 20.4867 24.8384 21.4667 23.6251 22.1317C22.4584 22.7733 20.9884 23.0767 19.5301 23.0417C20.3701 22.2833 20.8601 21.3383 20.9534 20.335C21.0701 18.8883 20.3818 17.5 19.0051 16.3917C18.2234 15.7733 17.3134 15.2833 16.3218 14.9217C18.9001 14.175 22.1434 14.6767 24.1384 16.2867C25.2118 17.15 25.7601 18.235 25.6551 19.355Z",
    fill: "url(#paint3_linear_640_6059)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6059",
    x1: 4.95825,
    y1: 7.03879,
    x2: 16.0416,
    y2: 7.03879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_6059",
    x1: 2.28662,
    y1: 19.4648,
    x2: 18.7133,
    y2: 19.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_640_6059",
    x1: 16.4619,
    y1: 8.29206,
    x2: 23.3366,
    y2: 8.29206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_640_6059",
    x1: 16.3218,
    y1: 18.179,
    x2: 25.6678,
    y2: 18.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserPrs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/userPrs.d05d6959.svg";
export { ForwardRef as ReactComponent };